<template>
  <div class="pay-supply">
    <div class="ly-card">
      <ul class="list">
        <li>
          <div class="title">操作时间</div>
          <div class="content flex-1">
            <el-date-picker
              v-model="date"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <el-input class="p-l-10" v-model="form.query" placeholder="学员/证件号/预约号/班级/操作员"></el-input>
          </div>
          <el-button
            type="text"
            @click.native="changeMore"
            :icon="isMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >{{ isMore ? '收起' : '更多条件' }}</el-button
          >
          <el-button type="primary" @click.native="search">查询</el-button>
          <!-- <el-button type="primary" @click.native="exportExcel">导出</el-button> -->
        </li>
        <template v-if="isMore">
          <li>
            <div class="title">订单归属</div>
            <div class="content">
              <remote-search :options="org_id" @input="value => levelChange(value, 'org_id')" />
              <remote-search
                :options="specialized_subject_id"
                :paramsData="professionP"
                @input="value => levelChange(value, 'specialized_subject_id')"
                ref="specialized_subject_id"
              />
            </div>
          </li>
          <li>
            <div class="title">支付方式</div>
            <div class="content">
              <el-radio-group v-model="form.supply_fee_method">
                <el-radio label="-1" key="-1" border>全部</el-radio>
                <el-radio :label="item.value" v-for="item in supplyMethod" :key="item.value" border>{{
                  item.label
                }}</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li>
            <div class="title">学&#12288;&#12288;年</div>
            <div class="content">
              <el-radio-group v-model="form.year" class="year-group">
                <el-radio label="-1" key="-1" border>全部</el-radio>
                <el-radio :label="item.value" v-for="item in years" :key="item.value" border>{{ item.label }}</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li>
            <div class="title">学&#12288;&#12288;期</div>
            <div class="content">
              <el-radio-group v-model="form.term">
                <el-radio label="-1" key="-1" border>全部</el-radio>
                <el-radio :label="item.value" v-for="item in terms" :key="item.value" border>{{ item.label }}</el-radio>
              </el-radio-group>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <div class="ly-card">
      <el-tabs v-model="form.supply_fee_status" @tab-click="search">
        <el-tab-pane name="-1" label="全部" :key="-1" value="-1"></el-tab-pane>
        <el-tab-pane
          :name="`${item.value}`"
          :label="item.label"
          v-for="item in supplyStatus"
          :key="item.value"
        ></el-tab-pane>
      </el-tabs>
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="form"
        ref="lyTable"
        class="width-full"
      >
        <template v-slot:action="row">
          <el-button type="primary" size="mini" @click="print(row)">打印</el-button>
        </template>
        <template v-slot:supply_no="row">
          <el-button type="text" size="mini" @click="openDg(row)">{{ row.supply_no }}</el-button>
        </template>
      </ly-table>
    </div>
    <order-inf-list :defData="defData" ref="orderInfo"></order-inf-list>
    <pay-detail
      ref="payDetail"
      :sign_up_id="defData.sign_up_id"
      :def="defData"
      :class_id="defData.class_id"
      :contact_id="defData.contact_id"
      isRefund
      :buttons="buttons"
      @success="search"
    />
  </div>
</template>
<script>
import { Radio, RadioGroup, DatePicker, Input, Tabs, TabPane } from 'element-ui';
import LyTable from '@/components/LyTable';
import OrderInfList from '@/components/OrderInfList';
import { paySupplyTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import RemoteSearch from '@/components/common/RemoteSearch';
import PayDetail from '@/components/PayDetail';
import { org_id, specialized_subject_id, class_id_org } from '@/utils/formConfigCommon';
import utils from '@/utils/utils';

export default {
  name: 'paySupply',
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ElDatePicker: DatePicker,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
    ElInput: Input,
    LyTable,
    OrderInfList,
    RemoteSearch,
    PayDetail
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: '',
      form: {

        org_id: '',
        specialized_subject_id: '',
        supply_fee_status: '-1',
        supply_fee_method: '-1',
        query: ''
      },
      isMore: false,
      getTableData: finance.getSupplyFee,
      tableHeader: paySupplyTable,
      org_id: {
        ...org_id.options,
        key: 'fee_level_id',
        clearable: true
      },
      specialized_subject_id: {
        ...specialized_subject_id.options,
        key: 'profession_id',
        clearable: true,
        disabled: false
      },
      class_id: {
        ...class_id_org.options,
        key: 'class_id',
        clearable: true,
        disabled: false
      },
      supplyStatus: [],
      supplyMethod: [],
      years: [],
      terms: [],
      dialogVisible: false,
      defData: {
        class_id: 0,
        contact_id: 0,
        sign_up_id: -1
      },
      buttons: [4, 5, 6]
    };
  },
  mounted() {
    this.search();
    this.init();
  },
  computed: {
    professionP() {
      return {
        org_id: this.form.org_id
      };
    },
    classP() {
      return {
        org_id: this.form.org_id,
        profession_id: this.form.profession_id
      };
    },
    term() {
      return this.$store.state.schoolYear.term;
    },
    year() {
      return this.$store.state.schoolYear.year;
    },
    classType() {
      return this.$store.state.schoolYear.classType;
    }
  },
  methods: {
    init() {
      finance.supplyStatus().then(res => {
        if (res) this.supplyStatus = res.data;
      });
      finance.supplyMethod().then(res => {
        if (res) this.supplyMethod = res.data;
      });
      this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
        if (data) {
          this.years = data.year;
          this.terms = data.term;
        }
      });
    },
    exportExcel() {
      const params = {};
      if (this.year && this.year !== -1) {
        params.year = this.year;
      }
      if (this.term && this.term !== -1) {
        params.term = this.term;
      }
      if (this.classType && this.classType !== -1) {
        params.class_type = this.classType;
      }
      finance
        .exportOrder({
          params: this.form
        })
        .then(data => {
          if (data) utils.downloadData(data, '订单列表');
        });
    },
    search() {
      if (this.date && Array.isArray(this.date) && this.date.length) {
        this.form = {
          ...this.form,
          supply_start_time: this.date[0],
          supply_end_time: this.date[1]
        };
      } else {
        delete this.form.supply_start_time;
        delete this.form.supply_end_time;
      }
      this.$refs.lyTable.setData();
    },
    changeMore() {
      this.isMore = !this.isMore;
      this.$nextTick(() => {
        if (this.$refs.lyTable) this.$refs.lyTable.setMaxHeight();
      });
    },
    detail(row) {
      this.$refs.orderInfo.open();
      finance
        .orderDetail({
          id: row.id
        })
        .then(res => {
          if (res && res.data) {
            this.defData = res.data.detail;
          }
        });
    },
    levelChange(value, key) {
      this.form[key] = value;
      if (key === 'org_id') {
        this.$refs.specialized_subject_id.clear();
      }
    },
    openDg(row) {
      this.defData = { ...row };
      if (row.supply_fee_status === 1) {
        // 未补费
        this.buttons = [4, 5, 6];
      } else if (row.supply_fee_status === 2) {
        // 已同意
        this.buttons = [2];
      } else {
        // 已拒绝
        this.buttons = [];
      }
      this.$refs.payDetail.open();
    },
    successStatus() {
      this.dialogVisible = false;
      this.search();
    },
    print(row) {
      finance
        .supplyFeePrint({
          record_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '打印成功');
          }
        });
    }
  }
};
</script>
<style lang="less">
.pay-supply {
  .el-input {
    width: 235px;
    margin-right: 20px;
  }
  ul.list {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      margin: 15px 0;
      display: flex;
      align-items: center;
      .title {
        margin-right: 20px;
      }
      .content {
        flex: 1;
      }
      .el-radio.is-bordered+.el-radio.is-bordered {
        margin-left: 0;
      }
      .year-group {
        line-height: 40px;
      }
    }
  }
  .right {
    float: right;
  }
  .ly-search-comp {
    display: inline-block;
  }
  .el-radio.is-bordered {
    min-width: 90px;
  }
}
</style>
